/*
  HistoHead slider arrows (featured collection), companion of hh-slider-arrows.css.
  - keeps the arrows level with the middle of the product images, whatever the image ratio
  - on desktop (990px and up) one click moves a whole row instead of a single product
*/
(function () {
  if (window.hhSliderArrows) return;
  window.hhSliderArrows = true;

  const desktop = window.matchMedia('(min-width: 990px)');

  function place(component) {
    const media = component.querySelector('.slider__slide .card__inner');
    if (!media || !media.offsetHeight) return;
    let top = media.offsetHeight / 2;
    let element = media;
    while (element && element !== component) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    if (element === component) component.style.setProperty('--hh-arrows-top', `${Math.round(top)}px`);
  }

  function init(component) {
    if (component.hhSliderArrows) return;
    component.hhSliderArrows = true;

    const slider = component.querySelector('.slider');
    if (!slider) return;

    place(component);
    new ResizeObserver(() => place(component)).observe(slider);

    // Runs before Dawn's own click handler, which reads data-step
    component.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.slider-button');
        if (!button) return;
        button.dataset.step = desktop.matches ? Math.max(1, component.slidesPerPage || 1) : 1;
      },
      true
    );
  }

  function initAll(root) {
    root.querySelectorAll('slider-component.hh-slider-arrows').forEach(init);
  }

  initAll(document);
  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
